import React, { Component } from 'react';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

export class CartonisedModalOk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show
        };
    }
    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered={true} size="sm">
                    <Modal.Header style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Modal.Title >{this.props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>{this.props.message}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.props.onClickOk}>
                            Ok
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default CartonisedModalOk;
